import { Connection } from '../../search/searchPropertiesByGeolocation.types';

export type ExcludedFeesAndTaxesResponseDtt = {
  sales: {
    groupSales: {
      excludedFeeAndTaxesByPropertyId: {
        roomFees: Connection<RoomFeeDetailsDtt>;
        roomTaxes: Connection<RoomTaxDetailsDtt>;
        serviceChargeTaxDetails: {
          serviceTaxInformation: string;
        };
      };
    };
  };
};

export type RoomFeeDetailsDtt = {
  feeId: string;
  feeAmount: number;
  feeAmountType: FeeAndTaxTypeDtt;
  computationTypeEnum: AmountTypeDtt;
  percentValue: string;
  name: string;
  otaCode: string;
  isIncludedInRate: boolean;
  effectiveDate: string;
  dependencyAttribute: {
    isPositiveDependency: boolean;
  };
  chargeUnit: ChargeFrequencyTypeDtt;
  chargeFrequency: ChargeFrequencyTypeDtt;
};

export type RoomTaxDetailsDtt = {
  taxId: string;
  taxAmount: number;
  taxAmountType: FeeAndTaxTypeDtt;
  computationTypeEnum: AmountTypeDtt;
  percentValue: string;
  name: string;
  otaCode: string;
  isIncludedInRate: boolean;
  effectiveDate: string;
  chargeUnit: ChargeFrequencyTypeDtt;
  chargeFrequency: ChargeFrequencyTypeDtt;
};

export enum AmountTypeDtt {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENT',
}

export enum ChargeFrequencyTypeDtt {
  DAILY = 'DAILY',
  PER_STAY = 'PER_STAY',
  ADDITIONS_PER_STAY = 'ADDITIONS_PER_STAY',
  COMPLIMENTARY = 'COMPLIMENTARY',
  FIRST_USE = 'FIRST_USE',
  HALF_DAY = 'HALF_DAY',
  HOURLY = 'HOURLY',
  MAXIMUM_CHARGE = 'MAXIMUM_CHARGE',
  MINIMUM_CHARGE = 'MINIMUM_CHARGE',
  ONE_TIME_USE = 'ONE_TIME_USE',
  ONE_WAY = 'ONE_WAY',
  OTHER = 'OTHER',
  OVER_MINUTE_CHARGE = 'OVER_MINUTE_CHARGE',
  PER_DOZEN = 'PER_DOZEN',
  PER_EVENT = 'PER_EVENT',
  PER_FUNCTION = 'PER_FUNCTION',
  PER_GALLON = 'PER_GALLON',
  PER_ITEM = 'PER_ITEM',
  PER_MINUTE = 'PER_MINUTE',
  PER_OCCURRENCE = 'PER_OCCURRENCE',
  PER_ORDER = 'PER_ORDER',
  PER_PERSON = 'PER_PERSON',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PER_PERSON_PER_STAY = 'PER_PERSON_ PER_STAY',
  PER_RENTAL = 'PER_RENTAL',
  PER_RESERVATION_OR_BOOKING = 'PER_RESERVATION_OR_BOOKING',
  PER_ROOM = 'PER_ROOM',
  PER_ROOM_PER_NIGHT = 'PER_ROOM_PER_NIGHT',
  PER_ROOM_PER_STAY = 'PER_ROOM_PER_STAY',
  PER_TRAY = 'PER_TRAY',
  PER_UNIT = 'PER_UNIT',
  ROUND_TRIP = 'ROUND_TRIP',
  WEEKLY = 'WEEKLY',
}

export enum FeeAndTaxTypeDtt {
  ADULT_ROLLAWAY_FEE = 'ADULT_ROLLAWAY_FEE',
  APPLICATION_FEE = 'APPLICATION_FEE',
  ASSESSMENT_OR_LICENSE_TAX = 'ASSESSMENT_OR_LICENSE_TAX',
  BANQUET_SERVICE_FEE = 'BANQUET_SERVICE_FEE',
  BED_TAX = 'BED_TAX',
  BEVERAGE_WITH_ALCOHOL = 'BEVERAGE_WITH_ALCOHOL',
  BEVERAGE_WITHOUT_ALCOHOL = 'BEVERAGE_WITHOUT_ALCOHOL',
  CHILD_ROLLAWAY_CHARGE = 'CHILD_ROLLAWAY_CHARGE',
  CITY_HOTEL_FEE = 'CITY_HOTEL_FEE',
  CITY_TAX = 'CITY_TAX',
  CONVENTION_OR_TOURISM_FEE = 'CONVENTION_OR_TOURISM_FEE',
  CONVENTION_TAX = 'CONVENTION_TAX',
  COUNTRY_TAX = 'COUNTRY_TAX',
  COUNTY_TAX = 'COUNTY_TAX',
  CRIB_FEE = 'CRIB_FEE',
  DESTINATION_AMENITY_FEE = 'DESTINATION_AMENITY_FEE',
  DESTINATION_MARKETING_FEE = 'DESTINATION_MARKETING_FEE',
  EARLY_CHECKOUT_FEE = 'EARLY_CHECKOUT_FEE',
  ENERGY_TAX = 'ENERGY_TAX',
  EVENT_CHARGE = 'EVENT_CHARGE',
  EXEMPT = 'EXEMPT',
  EXPRESS_HANDLING_FEE = 'EXPRESS_HANDLING_FEE',
  EXTRA_CHILD_CHARGE = 'EXTRA_CHILD_CHARGE',
  EXTRA_PERSON_CHARGE = 'EXTRA_PERSON_CHARGE',
  FEDERAL_TAX = 'FEDERAL_TAX',
  FOOD = 'FOOD',
  FOOD_AND_BEVERAGE_TAX = 'FOOD_AND_BEVERAGE_TAX',
  GOODS_AND_SERVICES_TAX = 'GOODS_AND_SERVICES_TAX',
  GUARANTEED_EARLY_CHECK_IN_FEE = 'GUARANTEED_EARLY_CHECK_IN_FEE',
  GUARANTEED_LATE_CHECK_OUT_FEE = 'GUARANTEED_LATE_CHECK_OUT_FEE',
  HOTEL_DEVELOPMENT_FEE = 'HOTEL_DEVELOPMENT_FEE',
  INSURANCE_FEE = 'INSURANCE_FEE',
  INSURANCE_PREMIUM_TAX = 'INSURANCE_PREMIUM_TAX',
  LOCAL_FEE = 'LOCAL_FEE',
  LOCAL_GOVERNMENT_FEE = 'LOCAL_GOVERNMENT_FEE',
  LODGING_TAX = 'LODGING_TAX',
  MAINTAINENCE_FEE = 'MAINTAINENCE_FEE',
  MAINTENANCE_FEE = 'MAINTENANCE_FEE',
  MISCELLANEOUS = 'MISCELLANEOUS',
  MISCELLANEOUS_FEE = 'MISCELLANEOUS_FEE',
  NATIONAL_GOVERNMENT_TAX = 'NATIONAL_GOVERNMENT_TAX',
  NOT_KNOWN = 'NOT_KNOWN',
  OCCUPANCY_TAX = 'OCCUPANCY_TAX',
  PACKAGE_FEE = 'PACKAGE_FEE',
  PET_SANITATION_FEE = 'PET_SANITATION_FEE',
  REFUNDABLE_PET_FEE = 'REFUNDABLE_PET_FEE',
  RESORT_FEE = 'RESORT_FEE',
  ROLLAWAY_FEE = 'ROLLAWAY_FEE',
  ROOM_SERVICE_FEE = 'ROOM_SERVICE_FEE',
  ROOM_TAX = 'ROOM_TAX',
  SALES_TAX = 'SALES_TAX',
  SERVICE_CHARGE = 'SERVICE_CHARGE',
  STANDARD = 'STANDARD',
  STANDARD_FOOD_AND_BEVERAGE_GRATUITY = 'STANDARD_FOOD_AND_BEVERAGE_GRATUITY',
  STATE_COST_RECOVERY_FEE = 'STATE_COST_RECOVERY_FEE',
  STATE_TAX = 'STATE_TAX',
  SURCHARGE = 'SURCHARGE',
  SURCHARGE_FOR_ORDINANCE_COSTS = 'SURCHARGE_FOR_ORDINANCE_COSTS',
  SURPLUS_LINES_TAX = 'SURPLUS_LINES_TAX',
  SUSTAINABILITY_FEE = 'SUSTAINABILITY_FEE',
  TOBACCO = 'TOBACCO',
  TOTAL_SURCHARGES = 'TOTAL_SURCHARGES',
  TOTAL_TAX = 'TOTAL_TAX',
  TOURISM_TAX = 'TOURISM_TAX',
  TRANSFER_OR_TRANSPORTATION_CHARGE = 'TRANSFER_OR_TRANSPORTATION_CHARGE',
  UNICEF_CHECKOUT_FOR_CHILDREN = 'UNICEF_CHECKOUT_FOR_CHILDREN',
  VALUE_ADDED_TAX = 'VALUE_ADDED_TAX',
  VAT_OR_GST_TAX = 'VAT_OR_GST_TAX',
  ZERO_RATED = 'ZERO_RATED',
}
